module.exports = __webpack_public_path__ + "img/whiteLogo.d36c71e9.png";